import React from "react";
import Routes from "./Routes";
import AuthInitializer from "./components/AuthInitializer";

function App() {
  return (
    <>
      <AuthInitializer />
      <Routes />
    </>
  );
}

export default App;
